import ApiService from '@/helpers/api.service';
import { Storage } from 'aws-amplify';
import moment from "moment";

const API = new ApiService();

const ENDPOINT = 'careers';
const S3_FOLDER = 'career-applicants';

export const state = {
  errors: null
}

export const mutations = {
  SET_ERROR(state, errors){
    state.errors = errors;
  },
}

export const actions = {
  actionCareers(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/${ENDPOINT}/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ERROR', response.data.errors);
          reject();
        });
    });
  },
  //interview sheet
  putInterviewSheet(context, params){
    return new Promise((resolve, reject) => {
      var allowedType = ["vnd.openxmlformats-officedocument.wordprocessingml.document","vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
      if(params.type && !allowedType.includes(params.type.toLowerCase())){
        reject("Filetype not allowed");
        return;
      }

      var metadata =  {
        customPrefix: {
          public: ''
        },
        expires: moment().add(365, 'days').toDate(),
      }
      if(params.type == 'vnd.openxmlformats-officedocument.wordprocessingml.document'){
        metadata['contentType'] = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        let name = params.filename.split(".");
        params.filename = name[0]+ ".docx";
      }
      if(params.type == "vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
        metadata['contentType'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        let name = params.filename.split(".");
        params.filename = name[0]+ ".xlsx";
      }
      // console.log(">>>>>>>",metadata['contentType']);
      Storage.put(`${S3_FOLDER}/${params.filename}`, params.base64, metadata)
        .then(stored => {
            console.log(stored);

            resolve(stored.key.replace(params.folder + "/", ""));
        })
        .catch(err => {
            console.log(err);
            reject(err);
        });
    });
  }
}

export const getters = {}